import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { loadEditOrder } from '../../redux/modules/cart'
import { loadMenuItemStart } from '../../redux/modules/personalize'
import { clearMenuItem } from '../../redux/modules/order'
import {
  favoriteCommentStart,
  getFavoriteCommentsStart
} from '../../redux/modules/favorite'

export const Comment = ({
  hash,
  isLoadingComments,
  favoriteComments,
  onEdit,
  isEditing,
  handleSubmit,
  cancel
}) => (
  <Fragment>
    {isLoadingComments ? (
      <i className="spinner secondary" />
    ) : (
      <span onClick={e => isEditing && e.stopPropagation()}>
        <FavoriteComment
          comment={
            favoriteComments &&
            favoriteComments.find(
              comment => comment.configurationHash === hash.hash
            )
          }
          hash={hash.hash}
          editing={isEditing}
          handleSubmit={handleSubmit}
          cancel={cancel}
        />
        {!isEditing ? (
          <button className="link editComment" onClick={onEdit}>
            Comment
          </button>
        ) : (
          <button
            className="link editComment"
            onClick={e => {
              e.stopPropagation()
              handleSubmit()
            }}
          >
            Save
          </button>
        )}
      </span>
    )}
  </Fragment>
)

export class CommentMenuItem extends Component {
  state = { isEditing: false }
  handleSubmit = event => {
    this.props.favoriteCommentStart(
      this.props.hash,
      document.getElementById(this.props.hash.hash).innerText.substring(0, 135)
    )
    this.setState({ isEditing: false })
  }

  render() {
    const {
      hash,
      clearMenuItem,
      loadEditOrder,
      favoriteComments,
      isLoadingComments
    } = this.props
    return (
      <div className="editPastOrderItem">
        <div
          onClick={e => {
            loadEditOrder(hash.hash, null, true)
            clearMenuItem()
          }}
          className="pastOrderSelector"
        >
          <div className="col-xs-12 placeorder-item_title">
            {hash.displayText}{' '}
            {hash && (
              <Comment
                {...{
                  hash,
                  isLoadingComments,
                  favoriteComments,
                  handleSubmit: this.handleSubmit,
                  onEdit: e => {
                    e.stopPropagation()
                    this.setState({ isEditing: true })
                  },
                  cancel: () => {
                    this.setState({ isEditing: false })
                  },
                  isEditing: this.state.isEditing
                }}
              />
            )}
          </div>
          <div className="col-xs-12 placeorder-item_description">
            {hash.modifiers
              .map(modifier =>
                modifier.answers.map(answer => `${answer.displayText}`)
              )
              .join(', ')}
          </div>
        </div>
      </div>
    )
  }
}

const sendCursorToEnd = e => {
  const el = e.target
  const range = document.createRange()
  const sel = window.getSelection()
  range.selectNodeContents(el)
  range.collapse(false)
  sel.removeAllRanges()
  sel.addRange(range)
}

export const FavoriteComment = ({
  hash,
  comment,
  editing,
  handleSubmit,
  cancel
}) => (
  <span
    className="favoriteComment"
    contentEditable={editing}
    suppressContentEditableWarning="true"
    id={hash}
    type="text"
    style={{
      borderBottom: editing ? '1px solid' : '',
      cursor: editing ? 'text' : 'default'
    }}
    ref={elem => editing && elem && elem.focus()}
    onFocus={sendCursorToEnd}
    onPaste={e => e.preventDefault()} // prevent pasting (avoids rich text)
    onKeyPress={e =>
      e.target.innerText.length > 135 &&
      e.keyCode !== 13 &&
      e.keyCode !== 27 &&
      e.preventDefault()
    } // limit char length
    onKeyDown={e =>
      (e.keyCode === 13 && handleSubmit()) || (e.keyCode === 27 && cancel())
    } // enter submits
  >
    {comment && comment.comments}
  </span>
)

class FavoritePersonalizePanel extends Component {
  constructor(props) {
    super(props)
    this.state = { isOpen: false }
    this.handleClick = this.handleClick.bind(this)
    this.loadMenuItem = this.loadMenuItem.bind(this)
  }

  loadMenuItem() {
    const { loadMenuItemStart, menuItemId } = this.props
    if (menuItemId) {
      loadMenuItemStart(menuItemId)
    }
  }

  handleClick() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }))
  }

  render() {
    const {
      hashes,
      clearMenuItem,
      loadEditOrder,
      favoriteComments,
      favoriteCommentStart,
      isLoadingComments
    } = this.props
    return (
      <div className="placeorder">
        <div className="favoritePersonalize">
          {hashes && hashes.length === 0 && (
            <div className="favoriteTitle">
              You currently do not have any past orders for this menu item
            </div>
          )}
          <ul className="placeorder-list">
            {hashes &&
              hashes.map(hash => (
                <li key={hash.orderItemId} className="placeorder-item">
                  <CommentMenuItem
                    {...{
                      clearMenuItem,
                      loadEditOrder,
                      favoriteCommentStart,
                      favoriteComments,
                      isLoadingComments,
                      hash
                    }}
                  />
                </li>
              ))}
          </ul>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = {
  loadEditOrder,
  loadMenuItemStart,
  clearMenuItem,
  favoriteCommentStart,
  getFavoriteCommentsStart
}

export default connect(
  null,
  mapDispatchToProps
)(FavoritePersonalizePanel)
